import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router";
import { ArrowBack } from "react-ionicons";

const FNavigator = ({ title, subtitle, reverse = true }) => {
  const { pathname, previousScreenDefinite, setPreviousScreenDefinite } =
    useContext(AuthContext);

  const route = useNavigate();

  let navigationFluxes = [
    // Home
    { route: "/", previousScreen: "/", flux: "Home" },
    // Envía tus documentos
    { route: "/MenuKycScreen", previousScreen: "/BasicInformationScreen", flux: "Pide" },
    // Mis Datos
    { route: "/ProfileOptionsScreen", previousScreen: "/", flux: "Pide" },
    {
      route: "/BasicInformationScreen",
      previousScreen: "/ProfileOptionsScreen",
      flux: "Pide",
    },

    {
      route: "/AddressScreen",
      previousScreen: "/ProfileOptionsScreen",
      flux: "Pide",
    },
    {
      route: "/CreateAddressScreen",
      previousScreen: "/AddressScreen",
      flux: "Pide",
    },

    {
      route: "/EmailScreen",
      previousScreen: "/ProfileOptionsScreen",
      flux: "Pide",
    },
    {
      route: "/CreateEmailScreen",
      previousScreen: "/EmailScreen",
      flux: "Pide",
    },
    {
      route: "/EmailOTPScreen",
      previousScreen: "/CreateEmailScreen",
      flux: "Pide",
    },

    {
      route: "/PhoneScreen",
      previousScreen: "/ProfileOptionsScreen",
      flux: "Pide",
    },
    {
      route: "/CreatePhoneScreen",
      previousScreen: "/PhoneScreen",
      flux: "Pide",
    },
    {
      route: "/PhoneOTPScreen",
      previousScreen: "/CreatePhoneScreen",
      flux: "Pide",
    },
    { route: "/GroupScreen", previousScreen: "/", flux: "Pide" },

    // Mis tarjetas
    { route: "/CardsScreen", previousScreen: "/", flux: "Pide" },
    {
      route: "/CreateCardScreen",
      previousScreen: "/CardsScreen",
      flux: "Pide",
    },
    {
      route: "/CardDetailScreen",
      previousScreen: "/CardsScreen",
      flux: "Pide",
    },
    // Mis bancos
    { route: "/BankScreen", previousScreen: "/", flux: "Pide" },
    { route: "/CreateBankScreen", previousScreen: "/BankScreen", flux: "Pide" },
    {
      route: "/BankDetailScreen",
      previousScreen: "/CreateBankScreen",
      flux: "Pide",
    },
    // Avisos Legales
    // Ajustes
    { route: "/ConfigScreen", previousScreen: "/", flux: "Pide" },
    {
      route: "/ChangePasswordScreen",
      previousScreen: "/ConfigScreen",
      flux: "Pide",
    },
    // Pide
    { route: "/CalcScreen", previousScreen: "/", flux: "Pide" },
    {
      route: "/PaymentMethodScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/BillScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/CheckScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/ZellePaymentScreen",
      previousScreen: -1,
      flux: "Pide",
    },

    {
      route: "/CodiPaymentScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/StorePaymentScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/ArcusPaymentScreen",
      previousScreen: -1,
      flux: "Pide",
    },
    {
      route: "/BankPaymentScreen",
      previousScreen: -1,
      flux: "Pide",
    },

    // Gasta
    { route: "/MainScreen", previousScreen: "/", flux: "gasta" },
    { route: "/RechargeScreen", previousScreen: "/MainScreen", flux: "gasta" },
    {
      route: "/RechargeOptionScreen",
      previousScreen: "/RechargeScreen",
      flux: "gasta",
    },
    { route: "/BillScreen2", previousScreen: -1, flux: "gasta" },

    { route: "/GiftCardScreen", previousScreen: "/MainScreen", flux: "gasta" },
    {
      route: "/AmountDropdownListScreen",
      previousScreen: "/GiftCardScreen",
      flux: "gasta",
    },

    {
      route: "/BillPaymentScreen",
      previousScreen: "/MainScreen",
      flux: "gasta",
    },
    {
      route: "/ConsultAccountScreen",
      previousScreen: "/BillPaymentScreen",
      flux: "gasta",
    },
    {
      route: "/ProductBalanceScreen",
      previousScreen: -1,
      flux: "gasta",
    },

    { route: "/ShareFiadoScreen", previousScreen: -1, flux: "gasta" },
    { route: "/ApplyForScreen", previousScreen: -1, flux: "gasta" },

    // Paga
    { route: "/LoansScreen", previousScreen: "/", flux: "gasta" },
  ];

  return (
    <div>
      <div className="p-2 flex content-center">
        {reverse == true ? (
          <div className="w-5/12 p-1  flex place-content-center cursor-pointer">
            <div
              className="w-8 h-8   rounded-full grid place-items-center"
              onClick={() => {
                const rout = navigationFluxes.filter(
                  (href) => href.route == pathname
                );

                if (previousScreenDefinite == null) {
                  route(rout.length > 0 ? rout[0].previousScreen : -1);
                } else {
                  route(previousScreenDefinite);
                  setPreviousScreenDefinite(null);
                }
              }}
            >
              <ArrowBack width="25px" height="25px" />
            </div>
          </div>
        ) : null}

        <div className="w-9/12 p-1  flex flex-col cursor-default place-content-center ">
          {subtitle ? <div className="text-xs -mt-1">{subtitle}</div> : null}
        </div>
      </div>
    </div>
  );
};

export default FNavigator;
